import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import ProcessSteps from '../components/ProcessSteps';
import CtaBand from '../components/CtaBand';

const values = [
  ['Foundation first', 'What you cannot see decides how it looks in ten years. We never cut corners below the surface.'],
  ['Honest guidance', 'We recommend what suits your home and how you live, not what is simply easiest to sell.'],
  ['Crafted details', 'Tight joints, clean cuts and crisp edges are the difference between paving and craftsmanship.']
];

function About() {
  return (
    <>
      <PageHero
        eyebrow="About us"
        title="Thirty years of"
        accent="laying it right."
        text="US Paver Co. is a paver installation company focused on one thing: outdoor surfaces that homeowners love coming home to."
        image="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2000&q=85"
      />
      <section className="py-24 md:py-32">
        <div className="wrap grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <p className="eyebrow">Our story</p>
            <h2 className="h-display mt-4 text-5xl md:text-7xl">Not just a surface. <em className="text-brick">A feeling.</em></h2>
            <p className="mt-6 max-w-lg text-sm leading-8 text-stone">
              For three decades we have helped homeowners transform everyday exteriors. We believe great paving does
              more than look beautiful. It makes the front of your home more welcoming, and life outside more
              enjoyable.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-ink p-12 text-white">
              <p className="h-display text-[9rem] leading-none text-clay">30<span className="text-6xl">+</span></p>
              <p className="mt-2 text-xs font-bold uppercase tracking-widest text-white/60">Years of paver craftsmanship</p>
            </div>
          </Reveal>
        </div>
      </section>
      <section className="bg-sand py-24">
        <div className="wrap grid gap-px bg-ink/10 md:grid-cols-3">
          {values.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.08} className="bg-bone p-10">
              <p className="h-display text-6xl text-brick">0{i + 1}</p>
              <h3 className="mt-5 text-lg font-bold">{t}</h3>
              <p className="mt-3 text-sm leading-7 text-stone">{d}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <ProcessSteps />
      <CtaBand />
    </>
  );
}

export default About;
